import React from "react";
import { useTranslation } from "react-i18next";

import SectionHeader from "../SectionHeader";
import { prosecutorTerms } from "../../../../content/prosecutors";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm.timeline";

export default function TimelineSection() {
  const { t } = useTranslation();

  return (
    <section className={style.timeline} id="linha-do-tempo">
      <SectionHeader
        label={t(`${keyI18n}.label`)}
        title={t(`${keyI18n}.title`)}
      />

      <article className={style.creation}>
        <span aria-hidden="true" className={`material-symbols-sharp ${style.creationIcon}`}>
          gavel
        </span>
        <div className={style.creationTexts}>
          <h3 className={`pgm-title-large ${style.creationTitle}`}>
            {t(`${keyI18n}.creation.title`)}
          </h3>
          <p className={`pgm-body-large ${style.creationText}`}>
            {t(`${keyI18n}.creation.description`)}
          </p>
        </div>
      </article>

      <ol className={style.events}>
        {prosecutorTerms.map((entry, index) => (
          <li className={style.event} key={`${entry.year}-${entry.name}-${index}`}>
            <div className={style.when}>
              <span className={`pgm-body-small ${style.date}`}>{entry.month}</span>
              <span className={`pgm-title-medium ${style.year}`}>{entry.year}</span>
            </div>

            <div className={style.card}>
              <img alt="" aria-hidden="true" className={style.photo} decoding="async" src={entry.photo} />
              <div className={style.who}>
                {entry.subrole && (
                  <span className={`pgm-body-medium pgm-body-medium--emphasized ${style.subrole}`}>
                    {entry.subrole}
                  </span>
                )}
                <span className={`pgm-body-medium ${style.role}`}>{entry.role}</span>
                <span className={`pgm-title-medium ${style.person}`}>{entry.name}</span>
              </div>
              <span
                className={[
                  "pgm-body-medium",
                  style.until,
                  entry.current ? style.untilCurrent : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <span aria-hidden="true" className="material-symbols-sharp">
                  {entry.current ? "check_circle" : "schedule"}
                </span>
                {entry.until}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
